import { render, staticRenderFns } from "./TransferContractDesignCandle.vue?vue&type=template&id=93a1f4a6&"
import script from "./TransferContractDesignCandle.vue?vue&type=script&lang=js&"
export * from "./TransferContractDesignCandle.vue?vue&type=script&lang=js&"
import style0 from "./TransferContractDesignCandle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports